/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';


var app            = require('mag-app'),
    pkgJson        = require('../../manifest.json'),
    XHRConstructor = null;


app.storage = {};

function catchMessage () {
    var sharedBackend = require('./modules/shared.backend').instance;

    app.stalker.request('message', {
        onload: function ( error, response ) {
            if ( !error && response.data.type ) {
                sharedBackend.emit('message', response.data);

                switch ( response.data.type ) {
                    case 'reboot':
                        if ( PLATFORM === 'MAG' ) {
                            console.log('reboot');

                            window.core.notify({
                                title: 'Reboot',
                                icon: 'info',
                                type: 'success',
                                timeout: 7000
                            });

                            setTimeout(function () {
                                // eslint-disable-next-line new-cap
                                window.top.gSTB.ExecAction('reboot');
                            }, 7000);
                        }
                        break;
                    case 'send_msg':
                        window.core.notify({
                            title: response.data.msg,
                            icon: 'info',
                            type: 'success',
                            timeout: 7000
                        });

                        break;
                    case 'send_msg_with_video':
                        window.core.notify({
                            title: response.data.msg,
                            icon: 'info',
                            type: 'success',
                            buttons: [
                                {
                                    value: gettext('Ok'),
                                    click: function () {
                                        window.core.intent({
                                            action: 'play',
                                            mime: 'content/media',
                                            data: {
                                                //uri: 'udp://@228.1.2.6:1234'
                                                uri: response.data.url
                                            }
                                            // eslint-disable-next-line no-unused-vars
                                        }, function ( error, context ) {
                                            if ( error ) {
                                                console.log(error);
                                            }
                                        });
                                    }
                                }
                            ]
                        });

                        break;
                    case 'update_image':
                        setTimeout(function () {
                            top.core.intent({
                                action: 'update',
                                data: {
                                    url: response.data.url
                                }
                            });
                        }, 200);

                        break;
                    default:
                        console.log('catch message with type: ' + response.data.type);
                        break;
                }
            }
        }
    });
}


function ping ( timeout ) {
    setTimeout(function () {
        console.log('PING START, timeout: ' + timeout);
        app.stalker.request('users/' + app.stalker.session.userId + '/ping', {
            onload: function ( error, data ) {
                console.log('PING END');
                if ( !error ) {
                    if ( data ) {
                        if ( data.data && data.data.message_available ) {
                            catchMessage();
                        }
                    }
                }

                ping(timeout);
            }
        });
    }, timeout);
}

window.fetch = function () {
    if ( !XHRConstructor ) {
        XHRConstructor = XMLHttpRequest;
    }

    return new XHRConstructor();
};

//app.addListener('keydown', function ( event ) {
//    var keys = require('stb-keys');
//
//    if ( event.code === keys.f4 ) {
//        if ( app.pages.eula ) {
//            app.route(app.pages.eula);
//        }
//    }
//});

// everything is ready
app.once('load', function () {
    window.core.once('ready', function ( event ) {
        var packages      = {},
            globalOptions = window.core.config.options,
            appsCount     = window.core.config.apps.filter(function ( appConfig ) {
                if ( appConfig.type === 'app' ) {
                    packages[appConfig.packageName] = appConfig;

                    return true;
                }

                return false;
            }).length;


        require('./modules/shared.backend').instance.session = app.stalker.session;

        if ( appsCount === 0 && typeof globalOptions.stalkerLoaderPath !== 'undefined' ) {
            event.stop = true;

            if ( typeof window.core.redirectTo === 'function' ) {
                window.core.redirectTo(globalOptions.stalkerHost + globalOptions.stalkerLoaderPath);
            }

            return;
        }

        // if ( PLATFORM === 'MAG' ) {
        // } else {
        ping(window.core.config.options.pingTimeout);
        // ping(2000);
        // }
    });
    require('spa-gettext').load({name: core.environment.language}, function () {
        var session = {};

        window.addEventListener('online', function () {
            window.core.notify({
                title: gettext('Network connected'),
                icon: 'info',
                type: 'success',
                timeout: 10000
            });
        });

        window.addEventListener('offline', function () {
            window.core.notify({
                title: gettext('Network disconnected'),
                icon: 'info',
                type: 'success',
                timeout: 10000
            });
        });

        session = core.plugins.ufsJson.loadSync();
        console.log(JSON.stringify(session));

        require('./modules/stalker.api.loader')({
            apiVersion: pkgJson.config.apiVersion,
            options: window.core.config.options,
            session: session
        });
    });
});
